const env = (process.env.NODE_ENV === 'production' ? 'prod' : 'dev');

const config = {
  "dev": {
    "jwtSecret": "123",
    "BASE_URL": "http://localhost:8889",
    "SOCKET_URL": "http://localhost:3578"
  },
  "prod": {
    "jwtSecret": "",
    "BASE_URL": "",
    "SOCKET_URL": ""
  }
}

module.exports = config[env];



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1